<template>
  <div class="excel-uploader">
    <button
      type="button"
      class="button primary upload-button"
      @click="showModal"
    >
      Import Letters File
    </button>

    <div
      class="modal upload-excel-modal"
      :class="{'is-active' : show_modal}"
    >
      <div
        class="modal-background"
        @click="resetData()"
      />
      <div class="modal-content">
        <div class="box">
          <h6>Import Letters File</h6>
          <!-- <p>Please make sure you have selected the right organization (on the top-left of the page) that you are planning to import to. Selected organization: <b> {{organizationName}} </b> </p> -->
          <input
            id="file-input"
            ref="upload"
            type="file"
            accept=".xls, .xlsx, .xlsm"
            class="button is-outlined file-uploader"
            @change="uploadExcel"
          >
          <p class="control has-text-right space-x-2">
            <button
              type="button"
              class="button is-white"
              @click="resetData()"
            >
              Cancel
            </button>
            <button
              type="button"
              :class="isVerifyApiLoading ? 'button primary is-loading' : 'button primary'"
              :disabled="!file"
              @click="handleAddVerifyClick()"
            >
              Upload
            </button>
          </p>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="resetData()"
      />
    </div>
  </div>
</template>

<script>
import DashboardService from '../../../services/dashboard.service';
import { isExcel } from '../../../utils/validationUtils';
import { Roles } from '../../../constants';

const dashboardService = new DashboardService();
export default {
  data() {
    return {
      show_modal: false,
      file: '',
      role: this.$store.state.user.role,
      roles: Roles,
      messages: {
        created: '',
        updated: '',
        deleted: '',
        rows: ''
      },
      responseError: '',
      isUploadLoading: false,
      isVerifyApiLoading: false
    };
  },
  methods: {
    uploadExcel(event) {
      const file = event.target.files[0];

      if (!isExcel(file.name)) {
        this.$root.$emit('showToast', { message: 'Failed to upload the excel file. Please choose correct format', options: { cssClass: 'is-danger', duration: 2500 } });
        this.resetData();
        return;
      }
      this.file = file;
    },
    showModal() {
      this.show_modal = true;
    },
    resetData() {
      this.show_modal = false;
      this.$refs.upload.value = '';
      this.file = '';
      this.responseError = '';
    },
    async handleAddVerifyClick() {
      if (!this.file) {
        this.$root.$emit('showToast', { message: 'Please choose a file before proceed', options: { cssClass: 'is-danger', duration: 5000 } });
        return;
      }
      const self = this;
      self.isVerifyApiLoading = true;
      const data = new FormData();
      data.append('file', this.file);

      await dashboardService.uploadLettersVerify(data)
        .then((response) => {
          const { status } = response.data;
          if (status === 'success') {
            self.isVerifyApiLoading = false;

            self.$root.$emit('showToast', { message: 'Letters successfully imported', options: { cssClass: 'is-success', duration: 5000 } });
            self.$events.fire('refresh');
            self.resetData();
          } else {
            self.isVerifyApiLoading = false;
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.isVerifyApiLoading = false;
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    }
  }
};
</script>
<style scoped lang="scss">
    .modal__error{
        margin-top: 15px;
        color: #ff0000;
    }
    .error__title{
        font-weight: 800;
    }
    .excel-uploader {
        .upload-excel-modal {
            .modal-content {
                .file-uploader {
                    margin-top: 15px;
                }
                .control {
                    margin-top: 15px;
                }
            }
        }
        .failed__row{
            display: flex;
            flex-direction: row;
            margin-bottom: 10px;
        }
        .checkbox__container{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 20px;
        }
        .checkbox__container .checkbox{
            margin-right: 10px;
            font-weight: 700;
        }
        .input__checkbox{
            margin-right: 10px;
        }
        .failed-items-modal {
            .failed-items {
                .failed-item {
                    margin-top: 25px;

                    .tenant-name {
                        font-weight: bold;
                        font-size: 18px;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
</style>
